export const RESPONSAVEIS_LIST = 'RESPONSAVEIS_LIST';
export const RESPONSAVEIS_LIST_START = 'RESPONSAVEIS_LIST_START';
export const RESPONSAVEIS_LIST_SUCCESS = 'RESPONSAVEIS_LIST_SUCCESS';
export const RESPONSAVEIS_LIST_ERROR = 'RESPONSAVEIS_LIST_ERROR';

export const PARAMS = 'PARAMS';
export const PARAMS_START = 'PARAMS_START';
export const PARAMS_SUCCESS = 'PARAMS_SUCCESS';
export const PARAMS_ERROR = 'PARAMS_ERROR';
